/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Witty_Still_Finch_SplashInputs */

const fr_witty_still_finch_splash = /** @type {(inputs: Witty_Still_Finch_SplashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrouve tous les paiements et abonnements liés à ton compte.`)
};

/**

* @param {Witty_Still_Finch_SplashInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const witty_still_finch_splash = /** @type {((inputs?: Witty_Still_Finch_SplashInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Witty_Still_Finch_SplashInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_witty_still_finch_splash(inputs)
});